import { Button, Modal } from "components"
import { FormProvider, useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"
import toast from "react-hot-toast"
import { useApi } from "utils"
import { SelectOptionType } from "types"
import { FormWarehouse, ListWarehouse } from "../types"
import { FormSection } from "./FormSection"

const schema = yup.object({
  warehouse_code: yup.string().label("Code").required().max(3, "Max 3 characters"),
  warehouse_name: yup.string().label("Warehouse").required().max(200),
  location_id: yup.number().label("Location").required(),
})

export function UpdateModal({ data, toggle, refetch, locationOptions, locationLoading }: { data: ListWarehouse; toggle: () => void; refetch: () => void; locationOptions: SelectOptionType[]; locationLoading: boolean }) {
  const api = useApi()
  const methods = useForm<FormWarehouse>({
    defaultValues: {
      warehouse_code: data.warehouse_code,
      warehouse_name: data.warehouse_name,
      location_id: data.location_id,
      description: data.description,
    },
    resolver: yupResolver(schema) as any
  })

  const onSubmit = (value: FormWarehouse) => {
    return new Promise<void>((resolve) => {
      toast.promise(
        api.put(`/location-warehouse/edit?location_warehouse_id=${data.location_warehouse_id}`, value),
        { loading: "Loading...", success: (res) => res.data.message, error: (err) => err.response.data.message }
      ).then(() => { toggle(); refetch() }).catch(() => {}).finally(resolve)
    })
  }

  return (
    <Modal isOpen title="UPDATE WAREHOUSE" closeModal={toggle}>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <Modal.Body>
            <FormSection locationOptions={locationOptions} locationLoading={locationLoading} />
          </Modal.Body>
          <Modal.Footer className="text-end">
            <Button type="submit" color="primary" loading={methods.formState.isSubmitting ? "true" : undefined}>Save</Button>
          </Modal.Footer>
        </form>
      </FormProvider>
    </Modal>
  )
}
